import * as L from 'leaflet';
import {
  ParamsCreateCircle,
  ResponseCreateCircle,
} from '../models/manager-leaflet.model';

const DEFAULT_OPTIONS: L.PathOptions = {
  fillColor: '#1976D2',
  fillOpacity: 0.2,
  color: '#1976D2',
  weight: 3,
  opacity: 0.8,
};

const DEFAULT_RADIUS = 100;

export function createCircle(params: ParamsCreateCircle): ResponseCreateCircle {
  try {
    const error = managerValidations(params);
    if (error) {
      return {
        circle: null,
        error,
      };
    }

    const finalOptions: L.PathOptions = {
      ...DEFAULT_OPTIONS,
      ...(params.options ?? {}),
    };

    const radius = params.radius ?? DEFAULT_RADIUS;

    const circle = new L.Circle(
      [params.coordinates.latitude, params.coordinates.longitude],
      radius,
      finalOptions
    );

    if (!circle) {
      return {
        circle: null,
        error: 'No se pudo crear el círculo',
      };
    }

    return { circle, error: null };
  } catch (error) {
    return {
      circle: null,
      error: 'Error desconocido al crear círculo',
    };
  }
}

function managerValidations(params: ParamsCreateCircle): string | null {
  const { coordinates } = params;
  const { latitude, longitude } = coordinates;

  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return 'Las coordenadas deben ser números válidos';
  }

  if (isNaN(latitude) || isNaN(longitude)) {
    return 'Las coordenadas no pueden ser NaN';
  }

  if (latitude < -90 || latitude > 90) {
    return 'La latitud debe estar entre -90 y 90';
  }

  if (longitude < -180 || longitude > 180) {
    return 'La longitud debe estar entre -180 y 180';
  }

  return null;
}
